import styled from "@emotion/styled";
import { EditorProps } from "@monaco-editor/react";
import { fontFamily, palette, space } from "@stedi/dls/constants";
import { MonacoEditor } from "@stedi/dls/MonacoEditor";
import type { editor } from "monaco-editor";

const SEditorLoader = styled.div({
  width: "100%",
  height: "100%",
  background: palette.gray6,
});

const SMonacoEditor = styled(MonacoEditor)({
  // Dim the collapse icons unless the editor is hovered or focused
  ".margin-view-overlays": {
    opacity: 0.4,
    transition: "opacity 0.3s ease-in-out",
  },
  "&:hover, &:focus-within": {
    ".margin-view-overlays": {
      opacity: 1,
    },
  },

  // Make the background of the editor transparent so it matches the background color of its parent container
  ".monaco-editor, .monaco-editor-background, .monaco-editor .margin": {
    backgroundColor: "transparent !important",
  },

  pointerEvents: "none",
  "@media (pointer: fine)": {
    pointerEvents: "unset",
  },
});

const BaseEditor = ({ options, ...props }: EditorProps) => {
  return (
    <SMonacoEditor
      loading={<SEditorLoader />}
      options={{
        ...defaultMonacoOptions,
        ...options,
      }}
      {...props}
    />
  );
};

export { BaseEditor };

const defaultMonacoOptions: editor.IStandaloneEditorConstructionOptions = {
  folding: true,
  fontFamily: fontFamily.mono,
  glyphMargin: false,
  hover: {
    sticky: false,
  },
  lineNumbers: "off",
  lineNumbersMinChars: 0,
  occurrencesHighlight: false,
  overviewRulerLanes: 0,
  renderLineHighlight: "none",
  selectionHighlight: false,
  showFoldingControls: "mouseover",
  padding: { top: 0, bottom: space.s2 },
  /**
   * To reduce the excessive left and right padding.
   */
  lineDecorationsWidth: space.s2,
  fixedOverflowWidgets: true,
  tabSize: 2,
  scrollbar: {
    alwaysConsumeMouseWheel: false,
    useShadows: false,
    verticalScrollbarSize: 6,
    verticalSliderSize: 6,
  },
};
